

import React, { forwardRef, ReactNode } from "react";
import styles from './PageContainer.module.scss';

interface Props {
    children?: ReactNode;
}
export type Ref = HTMLDivElement;

const PageContainer = forwardRef<Ref, Props>((props, ref) => (
    <div ref={ref} className={styles.form}>
        {props.children}
    </div>
));


export default PageContainer;